export var forceReload = function() {
    // Done for non-standard forceGet parameter in firefox:
    // https://searchfox.org/mozilla-central/source/dom/base/Location.cpp#551
    location.reload(true);
};
